import http from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type {
  CreatorDict,
  CreatorSaveReq,
  CreatorStatusResp,
  EnterpriseDict,
  EnterpriseSaveReq,
  EnterpriseStatusResp,
} from '@/types/apply'

/* 创作者入驻 */
export function getCreatorDict(): Promise<ApiResponse<CreatorDict>> {
  return http.get<ApiResponse<CreatorDict>>('/app/apply/creator/dict').then((r) => r.data)
}

export function getCreatorStatus(): Promise<ApiResponse<CreatorStatusResp>> {
  return http.get<ApiResponse<CreatorStatusResp>>('/app/apply/creator/status').then((r) => r.data)
}

export function saveCreator(payload: CreatorSaveReq): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/apply/creator/save', payload).then((r) => r.data)
}

/* 企业入驻 */
export function getEnterpriseDict(): Promise<ApiResponse<EnterpriseDict>> {
  return http.get<ApiResponse<EnterpriseDict>>('/app/apply/enterprise/dict').then((r) => r.data)
}

export function getEnterpriseStatus(): Promise<ApiResponse<EnterpriseStatusResp>> {
  return http
    .get<ApiResponse<EnterpriseStatusResp>>('/app/apply/enterprise/status')
    .then((r) => r.data)
}

export function saveEnterprise(payload: EnterpriseSaveReq): Promise<ApiResponse<null>> {
  return http.post<ApiResponse<null>>('/app/apply/enterprise/save', payload).then((r) => r.data)
}
